export const ACCESS_TOKEN_COOKIE_NAME = 'stashAccessToken';
export const USER_ID_COOKIE_NAME = 'stashUserID';
export const UUID_COOKIE_NAME = 'stashUUID';
export const DEVICE_ID_COOKIE_NAME = 'stashDeviceID';

// Written by web-reg (value is the admitted user's uuid, max-age 7 days) when a
// user is admitted to the accountless app entry experience. stash-web only
// reads and deletes it — the assignment is made once in web-reg at advisory
// e-sign, so reading LaunchDarkly here would enrol users a hop too early.
export const ACCOUNTLESS_APP_ENTRY_COOKIE_NAME = 'stashAccountlessAppEntry';

export const REFRESH_TOKEN_COOKIE_NAME = 'stashRefreshToken';

export const SESSION_TIMEOUT_INTERVAL =
	window.Stash.env === 'production' ? 1000 * 60 * 20 : 9999999999;

//never allow access token to expire by refreshing it every 4 minutes = 240000 ms
export const TOKEN_REFRESH_INTERVAL =
	process.env.STASH_ENV === 'local' ? 3156000000000 : 240000;

export const IDV_FLOW_NEXT_STEP = 'idvFlowNextStep';
export const IDV_FLOW_PARENT = 'idvFlowParent';
export const IDV_RETURN = 'idvReturn';
export const ATTRIBUTION_PROPERTIES = 'attribution_properties';

export const REAUTH_REFRESH_TOKEN_COOKIE_NAME = 'reauthRefreshToken';
export const REAUTH_REFRESH_TOKEN_COOKIE_MAX_AGE = 15; // seconds — intentionally short-lived to survive only the redirect hop
export const REAUTH_REFRESH_TOKEN_COOKIE_DOMAIN = '.stash.com';
